/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature8Inputs */

const ja_playdata_pricing_feature8 = /** @type {(inputs: Playdata_Pricing_Feature8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程別の統計（5分ごとの内訳）`)
};

const en_playdata_pricing_feature8 = /** @type {(inputs: Playdata_Pricing_Feature8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics by date and time (5 minute breakdowns)`)
};

/**
* | output |
* | --- |
* | "Statistics by date and time (5 minute breakdowns)" |
*
* @param {Playdata_Pricing_Feature8Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature8 = /** @type {((inputs?: Playdata_Pricing_Feature8Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature8Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature8(inputs)
	return en_playdata_pricing_feature8(inputs)
});